// extracted by mini-css-extract-plugin
export default {"checkbox-tag":"checkbox-tag-module__checkbox-tag___oqBTh"};